const contactStrutture = () => {
    const BASE_URL = document.getElementById('base_url').value;
    let endpoint_results = `${BASE_URL}/wp-json/api/v1/strutture`;

	if ( document.getElementById('contact-strutture') ) {
		var app = new Vue({
			el: '#contact-strutture',
			    data() {
				    return {
                        strutture : [],
                        selectedRegione:'',
                        selectedProvincia:'',
                        selectedStruttura:'',
                        selectedTelefono:'',
                        prevStruttura: '',
                    }
			    },
                mounted(){
                    fetch( endpoint_results )
                    .then(res => res.json())
                    .then(data => {
                        
                        let struttureTemp = data.map( item => {
                            const { nome, regione, provincia, province_attivita, telefono, telefono_prenotazioni } = item;
                            return {
                                nome,
                                regione,
                                provincia,
                                province_attivita,
                                telefono,
                                telefono_prenotazioni
                            }
                        })
                        struttureTemp.forEach(str => {
                            let province = []
                            if (str.provincia != null){
                                province = [
                                    ...str.province_attivita,
                                    str.provincia
                                ] 
                            }   
                            str.province = [...new Set(province)]
                            str.telefono = str.telefono_prenotazioni ? str.telefono_prenotazioni : str.telefono
                        });
                        this.strutture = struttureTemp;
                    })
                    this.showFiltersUI();
                },
                methods: {
                    showFiltersUI(){
                        let selettoriFiltriSearchInput = document.querySelectorAll(".filters-item.--search .filter-search__input input");
                        selettoriFiltriSearchInput.forEach(el => {
                            /* FOCUS MOSTRA LISTA */
                            el.addEventListener("focus", e => {
                                let isVisible = el.closest(".filters-item").classList.contains('visible-list');
                                selettoriFiltriSearchInput.forEach(el => {
                                    el.closest(".filters-item").classList.remove('visible-list');
                                });
                            
                                el.closest(".filters-item").classList.toggle('visible-list',!isVisible);
                            });
                        });
                        /* click fuori da input nasconde */
                        window.addEventListener('mouseup', function(e){   
                            selettoriFiltriSearchInput.forEach(el => {
                                if (!el.contains(e.target) && el.closest(".filters-item").classList.contains('visible-list')){
                                    el.closest(".filters-item").classList.remove('visible-list');
                                }
                            });
                        });
                    },
                    selectCurrentFilterUI(selectedFilter, selectedValue){
                        if(selectedFilter == 'regione'){
                            this.selectedRegione = selectedValue;
                        } else if (selectedFilter == 'provincia'){
                            this.selectedProvincia = selectedValue;
                        }
                        else if (selectedFilter == 'struttura'){
                            this.selectedStruttura = selectedValue;
                            this.prevStruttura = selectedValue;
                            this.selectedTelefono = this.computedStrutture[0].telefono;
                        }
                    },
                    highlightResult(current, filter) {
                        var str = current;
                        var regex = new RegExp(filter, 'i');
                        var indexQuery = (str.toLowerCase()).indexOf(filter.toLowerCase());
                        var highlightText = str.substring(indexQuery, indexQuery + filter.length);
                        return str.replace(regex, '<span class="fw-bold">' + highlightText + '</span>')
                    }
                },
                
                computed: {
                    computedStrutture(){			
                        
                        let structure =  this.strutture.filter( //controllo tutti gli item e mi ritorna solo gli elementi per cui il return è sempre true
    
                            (item) => {	
                            var regione = this.selectedRegione ? (item.regione.toLowerCase().includes(this.selectedRegione.toLowerCase())) : true, 
                                //provincia = this.selectedProvincia ? (item.provincia.toLowerCase().includes(this.selectedProvincia.toLowerCase())) : true,
                                provincia = this.selectedProvincia ? (item.province.find(r=> r.toLowerCase().includes(this.selectedProvincia.toLowerCase()))) : true, 
                                struttura = this.selectedStruttura ? (item.nome.toLowerCase().includes(this.selectedStruttura.toLowerCase())) : true;
                                return regione && provincia && struttura

                                
    
                            }
                        ) /* filter */
                        return structure.sort(function(a, b) {
							var textA = a.nome.toLowerCase();
							var textB = b.nome.toLowerCase();
							return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
						});
                    },
                    computedRegioni(){
                        let regioni = [];
                        this.computedStrutture.forEach(struttura => {
                            if(!regioni.includes(struttura.regione) && struttura.regione != '' && struttura.regione != null){
                                regioni.push(struttura.regione);
                            }
                        });
                        return regioni.sort();
                    },
                    computedProvince(){
                        let arr_province = [];
                        this.computedStrutture.forEach(struttura => {
                            arr_province = [...arr_province, ...struttura.province];

                        });
                        let province = [...new Set(arr_province)]
                        return province.sort();

                    },
                }
            }
        );
    }

}


export default contactStrutture;